<template>
  <div id="app">
    <CookiePolicy v-if="$store.state.cookiePolicy.data.showPopup"/>
    <Navigation />
    <div class="page">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Navigation from '@/components/Layout/Navigation'
import Footer from '@/components/Layout/Footer'
import CookiePolicy from '@/components/Popups/Cookie'

export default {
  name: 'App',
  components: {
    Navigation,
    Footer,
    CookiePolicy
  },
  created() {
    if (localStorage.ultimakerCookiePolicy !== 'true') {
      this.$store.commit('cookiePolicy/cookiePolicyCommit', {
        showPopup: true
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.page{
  padding-top: 70px;
}
</style>

<style lang="scss">
#webpack-dev-server-client-overlay{
  display: none !important;
}
</style>
